import React from 'react';
import { Modal, Button } from 'react-bootstrap';

const ViewPartnerModal = ({ show, onHide, partner }) => {
    if (!partner) return null;

    const formatValue = (value) => {
        return value || 'N/A';
    };

    return (
        <Modal show={show} onHide={onHide} size="lg">
            <Modal.Header closeButton>
                <Modal.Title>
                    <i className="ri-eye-line me-2"></i>
                    Partner Details
                </Modal.Title>
            </Modal.Header>
            <Modal.Body style={{ maxHeight: '70vh', overflowY: 'auto' }}>
                <div className="row">
                    {/* Logo */}
                    {partner.Uploadlogo && (
                        <div className="col-12 text-center mb-4">
                            <img
                                src={partner.Uploadlogo}
                                alt="Partner Logo"
                                style={{ maxHeight: '100px', maxWidth: '200px', borderRadius: 8, border: '1px solid #eee' }}
                                className="img-fluid"
                            />
                        </div>
                    )}

                    {/* Basic Information */}
                    <div className="col-12">
                        <h6 className="mb-3 text-primary border-bottom pb-2">Basic Information</h6>
                    </div>

                    <div className="col-md-6 mb-3">
                        <strong>Partner Name:</strong>
                        <div className="text-muted">{formatValue(partner.PartnerName)}</div>
                    </div>

                    <div className="col-md-6 mb-3">
                        <strong>Registration Number:</strong>
                        <div className="text-muted">{formatValue(partner.RegistrationNumber)}</div>
                    </div>

                    <div className="col-md-6 mb-3">
                        <strong>Partner Type:</strong>
                        <div className="text-muted">
                            <span className="badge badge-info">{formatValue(partner.PartnerType)}</span>
                        </div>
                    </div>

                    <div className="col-md-6 mb-3">
                        <strong>VAT Number:</strong>
                        <div className="text-muted">{formatValue(partner.VatNumber)}</div>
                    </div>

                    {/* Contact Information */}
                    <div className="col-12 mt-4">
                        <h6 className="mb-3 text-primary border-bottom pb-2">Contact Information</h6>
                    </div>

                    <div className="col-md-6 mb-3">
                        <strong>Contact Number:</strong>
                        <div className="text-muted">
                            <i className="ri-phone-line me-1"></i>
                            {formatValue(partner.ContactNumber)}
                        </div>
                    </div>

                    <div className="col-md-6 mb-3">
                        <strong>Email:</strong>
                        <div className="text-muted">
                            <i className="ri-mail-line me-1"></i>
                            {partner.Email ? (
                                <a href={`mailto:${partner.Email}`} className="text-decoration-none">
                                    {partner.Email}
                                </a>
                            ) : (
                                'N/A'
                            )}
                        </div>
                    </div>

                    <div className="col-md-6 mb-3">
                        <strong> In House Partner Manager:</strong>
                        <div className="text-muted">
                            <i className="ri-user-line me-1"></i>
                            {formatValue(partner.PartnerManager)}
                        </div>
                    </div>

                    <div className="col-12 mb-3">
                        <strong>Address:</strong>
                        <div className="text-muted">
                            <i className="ri-map-pin-line me-1"></i>
                            {formatValue(partner.Address)}
                        </div>
                    </div>

                    {/* Banking Details */}
                    {(partner.BankName || partner.AccountNumber || partner.SortCode || partner.IBAN || partner.SWIFT) && (
                        <>
                            <div className="col-12 mt-4">
                                <h6 className="mb-3 text-primary border-bottom pb-2">Banking Details</h6>
                            </div>

                            <div className="col-md-6 mb-3">
                                <strong>Bank Name:</strong>
                                <div className="text-muted">{formatValue(partner.BankName)}</div>
                            </div>

                            <div className="col-md-6 mb-3">
                                <strong>Account Number:</strong>
                                <div className="text-muted">{formatValue(partner.AccountNumber)}</div>
                            </div>

                            <div className="col-md-6 mb-3">
                                <strong>Sort Code:</strong>
                                <div className="text-muted">{formatValue(partner.SortCode)}</div>
                            </div>

                            <div className="col-md-6 mb-3">
                                <strong>IBAN:</strong>
                                <div className="text-muted">{formatValue(partner.IBAN)}</div>
                            </div>

                            <div className="col-md-6 mb-3">
                                <strong>SWIFT:</strong>
                                <div className="text-muted">{formatValue(partner.SWIFT)}</div>
                            </div>
                        </>
                    )}

                    {/* Additional Information */}
                    {partner.RemarksNote && (
                        <>
                            <div className="col-12 mt-4">
                                <h6 className="mb-3 text-primary border-bottom pb-2">Additional Information</h6>
                            </div>

                            <div className="col-12 mb-3">
                                <strong>Remarks/Notes:</strong>
                                <div className="text-muted bg-light p-3 rounded">
                                    {partner.RemarksNote}
                                </div>
                            </div>
                        </>
                    )}

                    {/* Metadata */}
                    {(partner.createdAt || partner.updatedAt) && (
                        <>
                            <div className="col-12 mt-4">
                                <h6 className="mb-3 text-primary border-bottom pb-2">Record Information</h6>
                            </div>

                            {partner.createdAt && (
                                <div className="col-md-6 mb-3">
                                    <strong>Created At:</strong>
                                    <div className="text-muted">
                                        <i className="ri-calendar-line me-1"></i>
                                        {new Date(partner.createdAt).toLocaleDateString('en-GB', {
                                            day: '2-digit',
                                            month: '2-digit',
                                            year: 'numeric',
                                            hour: '2-digit',
                                            minute: '2-digit'
                                        })}
                                    </div>
                                </div>
                            )}

                            {partner.updatedAt && (
                                <div className="col-md-6 mb-3">
                                    <strong>Last Updated:</strong>
                                    <div className="text-muted">
                                        <i className="ri-calendar-line me-1"></i>
                                        {new Date(partner.updatedAt).toLocaleDateString('en-GB', {
                                            day: '2-digit',
                                            month: '2-digit',
                                            year: 'numeric',
                                            hour: '2-digit',
                                            minute: '2-digit'
                                        })}
                                    </div>
                                </div>
                            )}
                        </>
                    )}
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onHide}>
                    Close
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default ViewPartnerModal;
